import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import { fadeInLeft } from "react-animations";
import { bodyColor } from "../../config/constants";
import { patientMainDivIndex } from "../../config/zIndex";

// Keyframes
const fadeInDownAnimation = keyframes`${fadeInLeft}`;

// Styles
export const PatientMainDiv = styled.div`
  margin: 0 auto 20px;
  width: 100%;
  max-width: 860px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: ${patientMainDivIndex};
  @media (max-width: 910px) {
    width: 85%;
  }
`;
export const PatientDiv = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  border-radius: 35px 0 0 35px;
  @media (max-width: 910px) {
    height: auto;
    flex-direction: column;
    align-items: flex-end;
    box-shadow: none;
    transition: all 0.5s ease-out;
  }
`;
export const UserDiv = styled.div`
  min-width: 230px;
  height: 100%;
  display: flex;
  align-items: center;
  border-radius: 35px 0 0 35px;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  @media (max-width: 910px) {
    width: 100%;
    border-radius: 35px 5px 5px 35px;
    position: relative;
    transition: all 0.5s ease-out;
  }
`;
export const AvatarLink = styled(Link)`
  width: 50px;
  height: 50px;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;
export const AvatarImg = styled.img`
  width: 100%;
  height: 100%;
`;
export const UserInfoDiv = styled.div`
  padding: 0 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #fff;
`;
export const UserText = styled.p`
  font-size: 14px;
  font-weight: 600;
`;
export const ShowAppsButton = styled.button`
  padding: 0 5px;
  height: 80%;
  display: none;
  border: none;
  background: transparent;
  outline: none;
  border-left: 2px solid ${bodyColor};
  position: absolute;
  right: 0;
  cursor: pointer;
  @media (max-width: 910px) {
    display: flex;
    align-items: center;
  }
`;
export const ShowAppsImg = styled.img`
  width: 15px;
  height: 15px;
`;
export const ProfileDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 5px 5px 15px rgb(0 0 0 / 15%);
  @media (max-width: 910px) {
    display: none;
  }
`;
export const ProfileLink = styled(Link)`
  padding: 0 10px;
  width: 100%;
  height: 80%;
  border-left: 2px solid ${bodyColor};
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
`;
export const ProfileImg = styled.img`
  width: 23px;
  height: 23px;
`;
export const ProfileText = styled.p`
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #808080;
`;
export const ApplicationDiv = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 0 5px 5px 0;
  box-shadow: 5px 5px 15px rgb(0 0 0 / 15%);
  @media (max-width: 910px) {
    margin-top: 2px;
    width: auto;
    max-width: 368px;
    height: 40px;
    display: ${({ show }) => (show ? "flex" : "none")};
    border-radius: 5px;
    box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
    animation: 0.5s ${fadeInDownAnimation};
  }
  @media (max-width: 475px) {
    max-width: 90%;
    overflow: scroll hidden;
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;
export const ApplicationProfileLink = styled(Link)`
  height: 80%;
  display: ${({ display }) => display && display};
  align-items: center;
  justify-content: center;
  text-decoration: none;
  @media (max-width: 910px) {
    display: flex;
  }
`;
export const ApplicationProfileImg = styled.img`
  margin: 0 9px;
  width: 25px;
  height: 25px;
`;
export const ApplicationLink = styled(Link)`
  height: 80%;
  border-left: 2px solid ${bodyColor};
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  text-decoration: none;
`;
export const ApplicationImg = styled.img`
  margin: 0 9px;
  width: 25px;
  height: 25px;
`;
export const ApplicationText = styled.p`
  margin: 0 9px 0 5px;
  font-size: 14px;
  font-weight: bold;
  color: #808080;
`;
export const ApplicationProfileText = styled.p`
  margin: 0 9px 0 0px;
  font-size: 14px;
  font-weight: bold;
  color: #808080;
`;
